import React from "react";
import TechnicalSkills from "../componets/TechnicalSkills";
import SoftSkills from "../componets/SoftSkills";
import { Fotter } from "../componets/Fotter";

export const Skills = () => {
  return (
    <>
 
    <div className="tec-s" >
    
      <TechnicalSkills />
      <SoftSkills/>
    </div>
    <Fotter/>
    </>
  );
};
